export default {
  meta: {
    title: '点位详情',
    url: '/locxx/pointdetail',
    parentPath: ['/locxx/pointmng'],
    breadcrumbs: {
      path: ['/locxx/pointmng', '/locxx/pointdetail'],
      name: ['点位管理', '点位详情'],
    },
  },
};
